import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-order-terms',
  templateUrl: './order-terms.component.html',
  styleUrls: ['./order-terms.component.less']
})
export class OrderTermsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
